import { environment } from 'src/environments/environment';

export interface AuthConfig {
  clientId: string;
  authority: string;
}

/** Mutable config populated by fetchAuthConfig() before Angular bootstraps. */
export const msalConfig: { auth: AuthConfig } = {
  auth: {
    clientId: '',
    authority: ''
  }
};

export const apiConfig = {
  scopes: ['user.read']
};

/** Fetches Azure AD auth config from the backend. Must complete before MSAL init. */
export const fetchAuthConfig = async (): Promise<void> => {
  const response = await fetch(`${environment.apiURL}/auth-config`);
  if (!response.ok) {
    throw new Error(`Failed to fetch auth config: ${response.status}`);
  }
  const config: AuthConfig = await response.json();
  msalConfig.auth.clientId = config.clientId;
  msalConfig.auth.authority = config.authority;
};
